module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "发布总部商品",
      "name": "relmall"
    }
  }, [_c('relMallList', {
    attrs: {
      "is-load": _vm.relmall_status,
      "distributor-id": _vm.distributor_id
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0c51d5e1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c51d5e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/storeshop/itemlist.vue
// module id = 2456
// module chunks = 0